import React from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';

const Contact = () => {
    return (
        <div className="mt-5 p-5 m-5">
            <h1 className="text-center mt-4">Contact</h1>
            <h4 className="text-center mt-4">Any Questions? Feel free to let us know!</h4>

            <p className="text-center mt-4">
                <strong >Office Address: House E-134, Road 9/2, Dakhin Rajapur, Sador, Khulna-1219 <br />
                    (Only for Course Instructors)</strong>
            </p>

            <p className="text-center mt-4">support@onlineacademy.com<br />
                (We usually back within 1-2 days) Or Call: 01770991502 </p>



            <div className="mt-5 p-5">
                <Form>
                    <Row className="mb-3">
                        <Form.Group className="mb-3" controlId="formGridAddress1">
                            <Form.Label>First Name</Form.Label>
                            <Form.Control placeholder="Write First Name" />
                        </Form.Group>

                        <Form.Group className="mb-3" controlId="formGridAddress2">
                            <Form.Label>Last Name</Form.Label>
                            <Form.Control placeholder="Write Last Name" />
                        </Form.Group>
                    </Row>

                    <Form.Group as={Col} controlId="formGridEmail">
                        <Form.Label>Email</Form.Label>
                        <Form.Control type="email" placeholder="Enter email" />
                    </Form.Group>


                    <Row className="mb-3">
                        <Form.Group as={Col} controlId="formGridCity">
                            <Form.Label>Subject</Form.Label>
                            <Form.Control />
                        </Form.Group>
                    </Row>

                    <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                        <Form.Label>Message</Form.Label>
                        <Form.Control as="textarea" rows={3} />
                    </Form.Group>

                    <Form.Group className="mb-3" id="formGridCheckbox">
                        <Form.Check type="checkbox" label="Check me out" />
                    </Form.Group>

                    <Button variant="primary" type="submit">
                        Submit
                    </Button>
                </Form>
            </div>

        </div>
    );
};

export default Contact;